import { RootState } from '../../../../config/store/rootReducer';
import { Country } from '../../../../types/countries';

export const makeGetCountriesSelector = () => (state: RootState): Country[] => state.globalInfo.countries;
